module.exports = __webpack_public_path__ + "img/home-help2.e6d55832.png";